// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sub-category-page[data-v-c9a8def2] h2{margin-bottom:1rem;margin-top:4rem}.faq-accordion[data-v-c9a8def2] .content p{margin-bottom:0}.page[data-v-c9a8def2]{border:1px solid #d7dfe1;border-radius:.4rem;color:#212528;font-weight:700;padding:1rem}@media screen and (min-width:768px){.page[data-v-c9a8def2]:hover{color:#017acd;-webkit-text-decoration:none;text-decoration:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
